import queryString from 'query-string';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Switch from 'react-switch';
import {fetchIdentificationWithRequestTokenOrRedirectOnFail} from '../../../actions/identification.actions';
import {
  addCurrentUserRewardAndUpdate,
  deleteCurrentUserRewardAndUpdate,
  getCurrentUserRewards,
} from '../../../actions/rewards.actions';
import {getPublicGameTitle} from '../../../constants/gameType.constants';
import {PageContainer, PageTitle, Table} from '../../Common/PageComponents';
import './rewards.scss';

const stateToProps = state => {
  return {
    currentUserRewards: state.reward.currentUserRewards,
    identification: state.identification,
    user: state.user,
  };
};

export class Rewards extends Component {
  componentDidMount() {
    this.props.dispatch(getCurrentUserRewards());
    const requestParams = queryString.parse(window.location.search);

    this.props.dispatch(
      fetchIdentificationWithRequestTokenOrRedirectOnFail(
        requestParams.identityToken,
        '/my-pc-bang/management/rewards/identification',
        this.props.history,
        '',
        this.props.user.duplicationInformation
      )
    );
  }

  updateCurrentUserReward = rewardToUpdate => {
    if (rewardToUpdate.enabled) {
      this.props.dispatch(deleteCurrentUserRewardAndUpdate(rewardToUpdate.gameType));
    } else {
      this.props.dispatch(addCurrentUserRewardAndUpdate(rewardToUpdate.gameType));
    }
  };

  render() {
    const {currentUserRewards = []} = this.props;
    if (!this.props.identification) {
      return null;
    }

    return (
      <PageContainer>
        <PageTitle title="게임별 혜택 관리" data-qa="rewardManagementPageTitle">
          Home &gt; MY PC방 &gt; <strong>혜택 관리</strong>
        </PageTitle>
        <div key={this.props.currentUserRewards} className="rewards">
          <Table>
            <thead>
              <tr>
                <th style={{width: '40%'}}>게임</th>
                <th>활성/비활성</th>
              </tr>
            </thead>
            <tbody style={{textAlign: 'center'}}>
              {currentUserRewards
                .filter(reward => reward.rewardType !== 'TFT' && reward.rewardType !== 'LEGACY_LOL')
                .map(reward => (
                  <tr key={reward.rewardId}>
                    <td>{getPublicGameTitle(reward.gameType)}</td>
                    <td>
                      <Switch
                        onColor={'#0bc4e2'}
                        onChange={() => this.updateCurrentUserReward(reward)}
                        checked={reward.enabled}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </PageContainer>
    );
  }
}

export default connect(stateToProps)(Rewards);
